import { getCameraAnimationTime } from "@/utils/camera-animation-time";
import { useCallback } from "react";
import { Camera, Vector3 } from "three";
import { FlyWalkAnimation } from "./flywalk-animation";

type MoveCameraToCbk = (pos: Vector3) => void;

/**
 * This hook provides the logic to compute a suitable animation when e.g. the user clicks a point in the minimap
 * to travel the camera there.
 *
 * @param camera The camera that is rendering the scene
 * @param endAnimation Callback to issue when the animation is over
 * @param setFlyWalkAnimation Callback to set the animation that this function creates
 * @returns A simple animation suitable to move the camera to a given position.
 */
export function useMoveCameraTo(
  camera: Camera,
  endAnimation: () => void,
  setFlyWalkAnimation: (animation: FlyWalkAnimation) => void,
): MoveCameraToCbk {
  return useCallback(
    (pos: Vector3) => {
      setFlyWalkAnimation({
        cameraAnimation: {
          position: pos,
          duration: getCameraAnimationTime(camera, pos),
          onAnimationFinished: endAnimation,
        },
      });
    },
    [camera, endAnimation, setFlyWalkAnimation],
  );
}
